module.exports = __webpack_public_path__ + "img/pr-8.34626427.png";